import { FC, ReactNode } from 'react';

import { Button, ButtonProps, CircularProgress } from '@mui/material';

interface IProps {
  isLoading?: boolean;
}

/**
 * Размер спиннера, px. 16px терялся на серой заливке disabled-кнопки; 20px — максимум,
 * влезающий в строку текста кнопки (размер large: 15px шрифт, line-height normal)
 */
const SPINNER_SIZE = 20;

/**
 * Доступное имя кнопки на время загрузки: спиннер заменяет текст, и без подписи
 * скринридер прочитал бы безымянную кнопку. Есть только у строкового children.
 * @param children - содержимое кнопки
 */
const getLoadingLabel = (children: ReactNode) =>
  typeof children === 'string' || typeof children === 'number'
    ? String(children)
    : undefined;

/**
 * Кнопка с возможностью отображения лоадера
 * @param root0 Пропсы
 * @param root0.isLoading Отображать ли лоадер
 * @param root0.disabled Заблокирована ли кнопка
 * @param root0.children Дочерние компоненты
 */
export const ButtonWithLoader: FC<IProps & ButtonProps> = ({
  isLoading,
  disabled,
  children,
  ...otherProps
}) => {
  return (
    <Button
      disabled={isLoading || disabled}
      aria-busy={!!isLoading}
      aria-label={isLoading ? getLoadingLabel(children) : undefined}
      {...otherProps}
    >
      {isLoading ? (
        // Отрицательные поля по вертикали: спиннер выше строки текста, кнопка не прыгает
        <CircularProgress size={SPINNER_SIZE} sx={{ my: '-2px' }} />
      ) : (
        children
      )}
    </Button>
  );
};
